export default __webpack_public_path__ + "static/media/WhatsApp Community_Khalifa.a2c3fca1.png";